import { useState } from 'react';
import Arch from './Arch';
import LinkText from './LinkText';
import SmartLink from './SmartLink';
import { Horizon, Peeks, splitArt } from './Art';

const LONG = 320;

function Member({ member, labels }) {
  const [open, setOpen] = useState(false);
  const chars = member.bio.reduce((n, p) => n + p.length, 0);
  const long = chars > LONG;
  const site = member.site && /^https?:/i.test(member.site) ? member.site.replace(/^https?:\/\/(www\.)?/i, '').replace(/\/$/, '') : '';

  return (
    <article className="member">
      <SmartLink url={member.site} className="member-photo" aria-label={`${member.name}, website`}>
        <Arch src={member.photo} alt={member.name} tone="light" position={member.focus} />
      </SmartLink>
      <h3 className="display display--s">{member.name}</h3>
      {member.role && <p className="member-role">{member.role}</p>}
      <div className={`member-bio ${long && !open ? 'is-clamped' : ''}`}>
        {member.bio.map((p, i) => <p key={i}><LinkText text={p} skip={member.name} /></p>)}
      </div>
      {long && (
        <button type="button" className="more" aria-expanded={open} onClick={() => setOpen(!open)}>
          {open ? labels.showLess : labels.readMore}
        </button>
      )}
      {site && <SmartLink url={member.site} className="member-site">{site}</SmartLink>}
    </article>
  );
}

export default function Band({ heading, band, recognition, labels, art }) {
  const { peeks, horizon } = splitArt(art);
  if (!band.length && !recognition.length) return null;
  return (
    <section id="band" className={`sec sec--sky band ${horizon ? 'sec--horizon' : ''}`} aria-labelledby="band-title">
      <Peeks items={peeks} />
      <div className="wrap">
        <h2 id="band-title" className="display">{heading}</h2>
        <div className="members">
          {band.map((m) => <Member key={m.key} member={m} labels={labels} />)}
        </div>

        {recognition.length > 0 && (
          <div className="split accolades">
            <h3 className="display display--s">{labels.recognition}</h3>
            <ul>
              {recognition.map((a) => <li key={a.key}>{a.text}</li>)}
            </ul>
          </div>
        )}
      </div>
      {horizon && <Horizon name={horizon.name} />}
    </section>
  );
}
